module.exports = __webpack_public_path__ + "img/police_sign.4495e6de.png";